import { breakpointSizes } from '@careguide/theme'
import { useMedia } from 'react-use'

type BreakpointTypes = 'mobile' | 'tablet' | 'desktop'

const useBreakpoint = (breakpoint: BreakpointTypes, defaultState: boolean = true) => {
  const isMobile = breakpoint === 'mobile'
  const mediaQuery = isMobile
    ? `(max-width: ${breakpointSizes.tablet - 1}px)`
    : `(min-width: ${breakpointSizes[breakpoint]}px)`
  return useMedia(mediaQuery, defaultState)
}

export default useBreakpoint
